<template>
  <div class="container_prop">
    <v-row align="stretch">
      <v-col
        v-for="(card, index) in cards"
        :key="card.title"
        cols="12"
        md="6"
        class="pa-3"
        :offset-md="
          index === cards.length - 1 && cards.length % 2 !== 0 ? 3 : 0
        "
      >
        <div class="feature-outline-s">
          <div class="feature-image-s" :class="card.color">
            <v-icon size="32" color="black">{{ card.icon }}</v-icon>
          </div>
          <div class="wrap-v-between">
            <div class="wrap-v-x-small-copy">
              <p class="paragraph-27 text-black">{{ card.title }}</p>
              <div class="card-text-secondary text-black text-left">
                {{ card.text }}
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "AuxiliaryCards",
  data() {
    return {
      cards: [
        {
          title: "Lojista",
          icon: "mdi-cash",
          color: "blue",
          text: `Venda produtos físicos sem investir em estoque!
                Escolha itens do nosso catálogo, anuncie na sua loja virtual com o seu preço, e a cada venda, um Maker imprime e envia direto para o seu cliente.
                Você não precisa se preocupar com a embalagem, o estoque ou a logística.
                E o melhor: sem mensalidade, sem taxa de adesão, sem compra mínima.
                Você só paga pela impressão do produto e pelo frete — quando e se vender.`,
        },
        {
          title: "Maker",
          icon: "mdi-printer-3d",
          color: "green",
          text: `Transforme sua impressora em fonte de renda.
                Aqui, você recebe pedidos de impressão prontos para executar — sem precisar montar uma loja, investir em marketing ou procurar os modelos mais promissores.
                Só precisa imprimir com qualidade, embalar e enviar.
                Não cobramos nada de mensalidade, não empurramos cursos pagos para você, e também não tem taxa de adesão.
                A gente cuida da demanda, e você cuida da produção.`,
        },
        {
          title: "Designer",
          icon: "mdi-pencil-ruler",
          color: "purple",
          text: `Publique seus modelos 3D, ganhe comissão por cada venda — sem precisar imprimir produtos ou atender clientes.
                Os Lojistas anunciam, os Makers imprimem, e você só precisa criar.
                Seu modelo vira um produto e você lucra com cada unidade vendida.
                E claro: sem mensalidade ou taxas para usar a plataforma.
                (Modelos com licença CC0 não geram comissão, por serem de uso livre.)`,
        },
        {
          title: "Empresas",
          icon: "mdi-cart",
          color: "orange",
          text: `Precisa desenvolver um produto exclusivo? Conte com nossos especialistas para modelagem 3D sob demanda. Basta clicar em Fazer Cotação, descrever sua ideia e agendaremos uma reunião para entender a viabilidade técnica do seu projeto e criar um orçamento personalizado para a modelagem do objeto que você deseja.`,
        },
      ],
    };
  },
};
</script>

<style scoped>
@media (max-width: 537px) {
  .container_prop {
    max-width: 95vw !important;
  }
}

.container_prop {
  max-width: 80vw;
  margin: 20px auto 60px auto;
}

.feature-outline-s {
  border: 1px solid #f5f5f5;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  padding: 32px;
  border: 1px solid #f5f5f5;
  border-radius: 8px;
  background-color: #fff;
  transition: transform 0.7s ease;
  width: 100%;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
  height: 320px;
}

@media screen and (max-width: 959px) {
  .feature-outline-s {
    height: 100%;
  }
}

.feature-outline-s:hover {
  transform: scale(1.05);
  cursor: pointer;
}
.feature-image-s {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  padding: 16px;
  min-width: 64px;
  min-height: 64px;
}
.feature-image-s.blue {
  background-color: #eaf6ff;
}
.feature-image-s.green {
  background-color: #e6fff3;
}
.feature-image-s.purple {
  background-color: #f0edff;
}
.feature-image-s.orange {
  background-color: #fff3e6;
}
.feature-image-s.teal {
  background-color: #e0f7f7;
}
.wrap-v-between {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
  flex: 1;
}
.wrap-v-x-small-copy {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.paragraph-27 {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #000;
  text-transform: uppercase;
}
.card-text-secondary {
  color: #555;
  font-size: 16px;
  line-height: 1.4;
}
.button-link {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #000;
  font-weight: 500;
  text-decoration: none;
  font-size: 16px;
}
</style>
